<div class="row mb-4">
    <div class="col-sm-12 mx-auto">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <h4 class="card-title col-12 mb-4">Create Admin</h4>
                    <form #theForm="ngForm" (ngSubmit)="submitForm(formGroup)" novalidate class="col-12">
                        <div [formGroup]="formGroup">
                            <div class="row mb-4">
                                <div class="col-md-4">
                                    <label class="required">Name</label>
                                </div>
                                <div class="col-md-8">
                                    <input type="text" formControlName="name" [class.is-invalid]="formGroup.get('name')?.invalid && (theForm.submitted || formGroup.get('name')?.touched)" placeholder="Type name" class="form-control" required>
                                    <div class="text-danger text-end w-100" *ngIf="formGroup.get('name')?.invalid && (theForm.submitted || formGroup.get('name')?.touched)">
                                        <small *ngIf="formGroup.get('name')?.errors?.required">Type name</small>
                                        <small *ngIf="formGroup.get('name')?.errors?.serverError">{{formGroup.get('name')?.errors?.serverError}}</small>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-md-4">
                                    <label class="required">Email</label>
                                </div>
                                <div class="col-md-8">
                                    <input type="email" formControlName="email" [class.is-invalid]="formGroup.get('email')?.invalid && (theForm.submitted || formGroup.get('email')?.touched)" placeholder="Type email" class="form-control" required>
                                    <div class="text-danger text-end w-100" *ngIf="formGroup.get('email')?.invalid && (theForm.submitted || formGroup.get('email')?.touched)">
                                        <small *ngIf="formGroup.get('email')?.errors?.required">Type email</small>
                                        <small *ngIf="formGroup.get('email')?.errors?.serverError">{{formGroup.get('email')?.errors?.serverError}}</small>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-md-4">
                                    <label class="required">Password</label>
                                </div>
                                <div class="col-md-8">
                                    <input type="text" formControlName="password" [class.is-invalid]="formGroup.get('password')?.invalid && (theForm.submitted || formGroup.get('password')?.touched)" placeholder="Type password" class="form-control" required>
                                    <div class="text-danger text-end w-100" *ngIf="formGroup.get('password')?.invalid && (theForm.submitted || formGroup.get('password')?.touched)">
                                        <small *ngIf="formGroup.get('password')?.errors?.required">Type password</small>
                                        <small *ngIf="formGroup.get('password')?.errors?.serverError">{{formGroup.get('password')?.errors?.serverError}}</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between align-items-center border-top pt-4 mt-4">
                            <div>
                                <div class="form-check">
                                    <input class="form-check-input" [(ngModel)]="stayPage" [ngModelOptions]="{standalone: true}" type="checkbox" id="stayPage" [attr.disabled]="loading.status ? 'disabled' : null">
                                    <label class="form-check-label" for="stayPage">
                                        Stay on this page
                                    </label>
                                </div>
                            </div>
                            <div class="text-end">
                                <button type="button" class="btn btn-secondary" (click)="back();" [attr.disabled]="loading.status ? 'disabled' : null">
                                    <i class="material-icons">close</i> &nbsp;
                                    Cancel
                                </button>
                                &nbsp;
                                <button type="submit" class="btn btn-primary" [attr.disabled]="loading.status ? 'disabled' : null">
                                    <i class="material-icons">save</i> &nbsp;
                                    Save
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
